@if (!isLoading) {
<div class="card">
  <div class="card-header">
    Overview
  </div>
  <div class="card-body">
    <div>
      <div><strong>Partner Manager</strong></div>
      @if (partnerManager) {
      <div>
        <span>{{ partnerManager.FullName }}</span>
        <span class="text-muted">({{ partnerManager.Username }})</span>
      </div>
      }
    </div>
  </div>
</div>
}